export enum Transferee {
    OwnerLandlord = 'owner-landlord',
    OwnerTransferee = 'owner-transferee',
    TenantTransferee = 'tenant-transferee',
    LandAgent = 'land-agent',
}
